import React from 'react';

import styled from 'styled-components';

import { CommunityOccupancy } from 'types/communities';
import { calculateOccupancy } from 'utils/data/communities';

import { CMA_SUMMARY_NOT_APPLICABLE_VALUE } from './constants';

const Container = styled.div`
  font-size: 14px;
`;

const Subtitle = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
`;

interface Props {
  occupancies: CommunityOccupancy[] | number | string;
  dataTestId?: string;
}

const CMASummaryTableDataOccupancy = ({ occupancies, dataTestId }: Props) => {
  if (typeof occupancies === 'number') {
    return <Container data-test-id={dataTestId}>{occupancies.toFixed(0)}%</Container>;
  }

  if (occupancies === CMA_SUMMARY_NOT_APPLICABLE_VALUE) {
    return <Container data-test-id={dataTestId}>{CMA_SUMMARY_NOT_APPLICABLE_VALUE}</Container>;
  }

  if (!Array.isArray(occupancies)) {
    return null;
  }

  const { totalUnits, occupiedUnits, occupancyPercentage } = calculateOccupancy(occupancies || []);
  const showUnitsRatio = typeof totalUnits === 'number' && totalUnits > 0;

  return (
    <>
      {occupancies?.length > 0 && (
        <Container data-test-id={dataTestId}>
          {occupancyPercentage}%
          {showUnitsRatio && (
            <Subtitle>
              {occupiedUnits}/{totalUnits} units
            </Subtitle>
          )}
        </Container>
      )}
    </>
  );
};

export default CMASummaryTableDataOccupancy;
